import { AccordionSection } from "react-rainbow-components";
import styled from "styled-components";

export const Container = styled.div`
  max-height: 100vh;
  flex: 1;
  display: flex;
  flex-direction: column;
  background-color: #f8f9fd;
  overflow: auto;
`;

export const HeaderTitle = styled.div`
  padding: 1rem 2rem;

  height: fit-content;
  & > h1 {
    margin: 0;
    color: #123559;
    text-align: start;
  }
  & > p {
    margin: 0;
    color: #555;
    text-align: start;
    font-weight: 200;
  }
`;

export const AccordionSectionCustom = styled(AccordionSection)`
  margin: 0.25rem 0.5rem;
  & section {
    padding: 0;
    border: none !important;
    & > div {
      margin-top: 0 !important;
    }
  }
`;
